/**
 *
 * LeafletControlPanel
 *
 */

// import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Panel } from 'react-bootstrap';

const LeafletControlPanel = styled(Panel).attrs({
  className: 'leaflet-control-layers',
})`
  &.panel {
    /* overflow: hidden; */
    .panel-heading,
    .panel-body {
      padding: 5px 10px;
    }
    margin-bottom: 0;
  }
`;

export default LeafletControlPanel;
